import { EditableText } from "@smartfire/components";
import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import { lazy, useState, useEffect } from "react";

import style from "./block.module.scss";

const InspectorLazy = lazy(() => import("./Inspector"));

function Block({
  numberColor,
  labelColor,
  anim,
  prefix,
  suffix,
  number,
  duration,
  textSize,
  labelSize,
}) {
  useInspectorControl(InspectorLazy, []);

  const [currentNumber, setCurrentNumber] = useState(anim ? 0 : number);

  useEffect(() => {
    if (anim) {
      let start = 0;
      const end = parseInt(number, 10); // S'assurer que number est un entier
      if (isNaN(end)) return;

      const stepTime = Math.abs(Math.floor(duration / end));

      const timer = setInterval(() => {
        start += 1;
        setCurrentNumber(start);
        if (start === end) {
          clearInterval(timer);
        }
      }, stepTime);

      return () => clearInterval(timer);
    } else {
      setCurrentNumber(number);
    }
  }, [anim, number, duration]);

  return (
    <BlockWrapper.Div className={style.block}>
      <p
        className={style.number}
        style={{ "--number-color": numberColor, "--number-size": textSize }}
      >
        {prefix && <span>{prefix}</span>}
        <span>{currentNumber}</span>
        {suffix && <span>{suffix}</span>}
      </p>
      <EditableText
        tagName={"p"}
        smartProp={"label"}
        placeholder={"Insérer un label..."}
        className={style.label}
        style={{ "--label-color": labelColor, "--label-size": labelSize }}
      />
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    number: smartProps.string.withDefault("20"),
    prefix: smartProps.string.withDefault(""),
    suffix: smartProps.string.withDefault(""),
    numberColor: smartProps.string.withDefault("#E0004D"),
    label: smartProps.string.withDefault("Label"),
    labelColor: smartProps.string.withDefault("#21244D"),
    anim: smartProps.bool.withDefault(false),
    duration: smartProps.number.withDefault(2000),
    textSize: smartProps.string.withDefault("36px"),
    labelSize: smartProps.string.withDefault("16px"),
  },
  setup: {
    title: "Number key Item",
    parent: ["smartfire/number-key"],
  },
});
